import React from 'react';
import Dialog from '../../toolkit/dialog';
import PrepareSubmit from './PrepareSubmit';
import { Select, TextField } from '../widgets';
import { CollectionModifyData } from '../interfaces';

const { Option } = Select;

export default abstract class BaseTab extends React.Component {

  protected abstract getActionType(): string;

  state = {
    model: '',
    condition: '',
    key: '',
    value: '',
    errors: {
      model: null,
      key: null,
      value: null,
      condition: null
    }
  }

  render() {
    return (
      <div className="row ltr text-left pt-2 pb-2">
        <div className="col-xxl-3 col-xl-4 col-lg-6 col-12">
          <label className="form-label">Collection</label>
          <Select defaultValue="1" defaultText="Select Name" onChange={this.handleSelectChange}>
            <Option value="User">User</Option>
            <Option value="Device">Device</Option>
            <Option value="Group">Group</Option>
            <Option value="Alarm">Alarm</Option>
            <Option value="Pref">Pref</Option>
          </Select>
          {this.renderError('model')}
        </div>
        <div className="col-xxl-3 col-xl-4 col-lg-6 col-12">
          <label className="form-label">Condition</label>
          <TextField
            style={{ fontFamily: '' }}
            hint='eg: {username: "09xxxx"}'
            onTextChange={this.handleTextFieldChange.bind(this, 'condition')}
          />
          {this.renderError('condition')}
        </div>
        <div className="col-xxl-3 col-xl-4 col-lg-6 col-12">
          <label className="form-label">Key</label>
          <TextField
            hint='eg: name'
            style={{ fontFamily: 'monospace' }}
            onTextChange={this.handleTextFieldChange.bind(this, 'key')} />
          {this.renderError('key')}
        </div>
        <div className="col-xxl-3 col-xl-4 col-lg-6 col-12">
          <label className="form-label">Value</label>
          <TextField
            hint='eg: Mamad'
            style={{ fontFamily: 'monospace' }}
            onTextChange={this.handleTextFieldChange.bind(this, 'value')} />
          {this.renderError('value')}
        </div>
        <button
          onClick={this.handleSubmit}
          className="ant-btn ant-btn-primary ant-btn-lg mx-auto mt-5">
            {(this.getActionType() === 'create') ? 'درخواست ایجاد' : 'درخواست بروزرسانی'}
          </button>
      </div>
    );
  }

  renderError = (key: string) => {
    const error = this.state.errors[key];
    if (!error) {
      return (<div className="input-error-message text-desc d-none"></div>);
    }
    return (<div className="input-error-message text-desc d-flex">{error}</div>);
  }

  handleTextFieldChange = (key: string, event: any) => {
    this.setState({ [key]: event.target.value });
  }

  handleSelectChange = (value) => {
    this.setState({ model: value });
  }

  handleSubmit = () => {
    const { errors, ...params } = this.state;
    let hasError = false;

    try {
      JSON.parse(params.condition.trim());
      errors.condition = null;
    }
    catch (e) {
      hasError = true;
      errors.condition = 'Invalid JSON';
    }

    if (params.key.trim() === '') {
      errors.key = 'Can not be empty';
      hasError = true;
    }
    else {
      errors.key = null;
    }

    if (params.model.trim() === '') {
      errors.model = 'Select your model';
      hasError = true;
    }
    else {
      errors.model = null;
    }

    this.setState({ errors });

    if (!hasError) {
      this.submit(this.getActionType(), params);
    }
  }

  submit = (type: string, data: CollectionModifyData) => {
    const dialog = new Dialog({
      rtl: true,
      title: 'برای اعمال تغییرات رمز خود را وارد کنید',
      size: 'small',
      message: PrepareSubmit,
      onClose: (success: boolean) => {
        if (success) {
          return this.resetForm();
        }
      }
    });
    dialog.show({ ...{ type }, ...data, ...{ keyId: data['key'] } });
  }

  resetForm = () => {
    this.setState({
      model: '',
      condition: '',
      key: '',
      value: '',
      errors: {
        model: null,
        key: null,
        value: null,
        condition: null
      }
    });
  }

}
